import React, { useEffect, useState, useContext } from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "./sendbird.css";
import {
  ChannelList,
  Channel,
  withSendBird,
  sendBirdSelectors
} from "sendbird-uikit";
import "sendbird-uikit/dist/index.css";
import ChannelHeader from "./ChannelHeader";
import ConversationPreview from "./ConversationPreview";
import ChatContext from "../../context/ChatContext";

function ChatPanel({ sdk, getCreateChannel }) {
  const [chatInitiated, setChatInitiated] = useState(false);
  const { chatInfo } = useContext(ChatContext);
  const [currentChannelUrl, setCurrentChannelUrl] = useState(null);

  useEffect(() => {
    const params =
      sdk && sdk.GroupChannelParams && new sdk.GroupChannelParams();
    const channelElement = document.getElementsByClassName(
      "sendbird-channel-header__title--right"
    );
    const channelHeaderLabel = (
      <span
        style={{ padding: "8px 0px" }}
        className="sendbird-label sendbird-channel-header__title--name sendbird-label--subtitle-2 sendbird-label--color-onbackground-1"
      >
        Conversations
      </span>
    );

    if (channelElement && channelElement.length) {
      ReactDOM.render(channelHeaderLabel, channelElement[0]);
    }

    if (params) {
      if (chatInfo.otherUserId) {
        params.addUserIds([chatInfo.userId, chatInfo.otherUserId]);
        params.isDistinct = true;

        sdk.GroupChannel &&
          getCreateChannel(params).then((channel) => {
            setCurrentChannelUrl(channel.url);
            setChatInitiated(true);
          });
      } else {
        const nochannelElement = document.getElementsByClassName(
          "sendbird-label sendbird-place-holder__body__text sendbird-label--body-1 sendbird-label--color-onbackground-2"
        );
        for (let i = 0; i < nochannelElement.length; ++i)
          ReactDOM.render(<span>No Conversation</span>, nochannelElement[i]);
        setChatInitiated(false);
      }
    }
  }, [sdk]);

  return (
    <div>
      <div className="sendbird-app__wrap">
        <div className="sendbird-app__channellist-wrap">
          <ChannelList
            renderChannelPreview={ConversationPreview}
            onChannelSelect={(channel) => {
              if (channel && channel.url) {
                setCurrentChannelUrl(channel.url);
              }
            }}
          />
        </div>
        <div className="sendbird-app__conversation-wrap">
          <Channel
            renderChatHeader={ChannelHeader}
            channelUrl={currentChannelUrl}
          />
        </div>
      </div>
    </div>
  );
}

const WithSendBird = withSendBird(ChatPanel, (state) => {
  return {
    sdk: sendBirdSelectors.getSdk(state),
    getCreateChannel: sendBirdSelectors.getCreateChannel(state)
  };
});

export default WithSendBird;
